export enum PsaTypes {
  Connectwise,
  Autotask,
  Halo = 5,
  SuperOps = 7,
}

export enum Language {
  English = 0,
  French = 1,
}

export const languages = {
  [Language.English]: 'en',
  [Language.French]: 'fr',
};

export interface IPortalConfig {
  caption: string;
  logo: string;
  colorScheme: string;
  psaType: PsaTypes;
  disableChats: boolean;
  allowReOpenChat: boolean;
  defaultTicketTemplateName: string;
  useDefaultTicketTemplate: boolean;
  verificationTechType: string;
  language: Language;
  slaBanner?: string;
  useHelpdeskAi?: boolean;
}

export interface ITechnicianData {
  techPhone?: string;
  techEmail?: string;
  afterHoursTechPhone?: string;
  afterHoursTechEmail?: string;
  techCompanyName?: string;
  techName?: string;
  useHelpdeskAi?: boolean;
}
